import { ScreenShot } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: `${routesMap.THEME_SCREEN_SHOT.path}/:id`,
      name: "Theme",
      key: `${routesMap.THEME_SCREEN_SHOT.path}/:id`,
      commonRoute: true,
      private: false,
      withAuth: false,
      element: <ScreenShot />,
    },
  ];
}
